import { useMemo } from "react";
import { useParams } from "react-router-dom";
import GenericPlanner from "../../../../feature-module/academic/planning/components/GenericPlanner/GenericPlanner";
import useGenericPlanner from "../../../../feature-module/academic/planning/hooks/useGenericPlanner";
import Loader from "../../../Common/loader";
import { useOutletContext } from "react-router-dom";
import { Alert } from "antd";
import { useTranslation } from "react-i18next";
import CustomAlert from "components/Common/ui/CustomAlert";

type Ctx = { student: any | null };

const StudentRoutineTab = () => {
  const { id } = useParams<{ id: string }>();
  const { student } = useOutletContext<Ctx>();
  const { t } = useTranslation();

  // if (!student) return null;
  const classId = useMemo(() => student?.class?.id, [student]);

  const plannerParams = useMemo(() => ({
    role: "student" as const,
    classIds: classId ? [classId] : []
  }), [classId]);

  const {
    data: plannerData,
    isLoading: plannerLoading,
    error: plannerError
  } = useGenericPlanner(plannerParams);

  if (plannerLoading) return <Loader />;

  return (
    <div className="p-2">

      <>
        {plannerLoading ? (
          <div className="d-flex justify-content-center my-5">
            <Loader />
          </div>
        ) : plannerError ? (
          <CustomAlert message={plannerError} type="error" showIcon />
        ) : !classId ? (
          <CustomAlert message={t("alert.no_class_assigned.message")} description={t("alert.no_class_assigned.description")} type="warning" showIcon />
        ) : (
          <div className="">
            <GenericPlanner role="student" data={plannerData} />
          </div>
        )}
      </>



    </div>
  );
};

export default StudentRoutineTab;
